<template>
    <div class="c-slider">
        <div v-for="(item, index) in wordsSorted"
             :key="item.id"
             :index="index"
             ref="card"
             class="c-card"
             :class="foundWordIds.indexOf(item.id) !== -1 ? 'c-card--found' : null"
             :data-id="item.id"
        >
            <div class="c-card__content">
                <p class="c-card__text w-4/5">{{ item.tip }}</p>

                <a v-if="item.href" class="c-card__button c-button w-auto absolute flex px-4 py-2 pr-12" :href="item.href" target="_blank">
                    <span class="c-button__text">
                    Hint
                    </span>
                    <span class="c-button__icon icon icon-arrow-small w-6 h-10"></span>
                </a>

                <div class="c-card__tip text-center">
                    <span class="text-12">{{ item.word.length }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { filter } from 'lodash'
    import gsap from "gsap"

    export default {
        name: 'PuzzleHintList',

        data () {
          return {
            wordsSorted: []
          }
        },

        mounted () {
            this.wordsSorted =  [...this.unfoundWords, ...this.foundWords]
        },

        methods: {
            animateCard (word_id) {
                const node = this.$el.querySelector('.c-card[data-id="' + word_id + '"]')
                const el = this.$el

                function getNextSiblings(el, filter) {
                    var siblings = [];
                    while (el = el.nextSibling) { if (!filter || filter(el)) siblings.push(el); }
                    return siblings;
                }

                const tl = gsap.timeline({
                    onComplete: () => {
                        this.$store.commit('setFoundWordIdToAnimate', { word_id: null })
                        node.classList.add("c-card--found");
                        this.$el.appendChild(node);
                    }
                });

                if (window.matchMedia('(min-width: 1200px)').matches) {
                     tl
                    .to(node, {
                        opacity: '.5',
                        duration: .5,
                        ease: "power1.inOut"
                    }, 0)
                    .to(node, {
                        y: "108px",
                        duration: .5,
                        ease: "power1.inOut"
                    })
                    .to(getNextSiblings(node), {
                        y: "-108px",
                        duration: .5,
                        ease: "power1.inOut"
                    })
                    .set([getNextSiblings(node), node], {
                        y: "0px",
                    })
                } else {
                    tl
                    .to(node, {
                        opacity: '.5',
                        duration: .5,
                        ease: "power1.inOut"
                    }, 0)
                    .to(node, {
                        x: "278px",
                        duration: .5,
                        ease: "power1.inOut"
                    })
                    .to(getNextSiblings(node), {
                        x: "-278px",
                        duration: .5,
                        ease: "power1.inOut"
                    })
                    .set([getNextSiblings(node), node], {
                        x: "0px",
                    })
                }
            },
        },

        watch: {
            foundWordIdToAnimate: function (newValue) {
                if (newValue === null) {
                    return
                }

                this.$nextTick(() => {
                    this.animateCard(newValue)
                })
            }
        },

        computed: {
            ...mapState({
                gridSettings: state => state.gridSettings,
                foundWordIds: state => state.foundWordIds,
                puzzle: state => state.currentPuzzle,
                foundWordIdToAnimate: state => state.foundWordIdToAnimate
            }),

            words () {
                return this.puzzle.words.filter(item => !item.is_bonus)
            },

            unfoundWords () {
                return filter(this.words, item => this.foundWordIds.indexOf(item.id) === -1)
            },

            foundWords () {
                return filter(this.words, item => this.foundWordIds.indexOf(item.id) !== -1);
            }
        }
    }
</script>
